import { editor as Editor, Position } from "monaco-editor";

import { CompletionLanguage } from "../../../generated/graphqlTypes";

export const TYPEAHEAD_LANGUAGE_MAP: Partial<
  Record<string, CompletionLanguage>
> = {
  python: "PYTHON",
  sql: "SQL",
  pgsql: "PGSQL",
  mysql: "MYSQL",
  redshift: "REDSHIFT",
  snowflake: "SNOWFLAKE",
};

export function getTypeaheadRegions(
  model: Editor.ITextModel,
  position: Position,
): {
  prefix: string;
  editableRegion: string;
  suffix: string;
} {
  // Grab everything in the cell before the current line
  const prefix =
    position.lineNumber === 1
      ? ""
      : model.getValueInRange({
          startLineNumber: 1,
          startColumn: 1,
          endLineNumber: position.lineNumber - 1,
          endColumn: model.getLineMaxColumn(position.lineNumber - 1),
        });

  // Grab only the current line with the cursor
  const currentLineText = model.getValueInRange({
    startLineNumber: position.lineNumber,
    startColumn: 1,
    endLineNumber: position.lineNumber,
    endColumn: model.getLineMaxColumn(position.lineNumber),
  });

  // Insert cursor marker at the current cursor position
  const beforeCursor = currentLineText.substring(0, position.column - 1);
  const afterCursor = currentLineText.substring(position.column - 1);
  const editableRegion = `${beforeCursor}<|user_cursor_is_here|>${afterCursor}`;

  // Grab everything from the next line to the end
  const suffix =
    position.lineNumber === model.getLineCount()
      ? ""
      : model.getValueInRange({
          startLineNumber: position.lineNumber + 1,
          startColumn: 1,
          endLineNumber: model.getLineCount(),
          endColumn: model.getLineMaxColumn(model.getLineCount()),
        });

  return {
    prefix,
    editableRegion,
    suffix,
  };
}
